import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "block space-y-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "border-t-2 !my-4 w-full" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConnectProviderListItem = _resolveComponent("ConnectProviderListItem")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.providersVisible, (p) => {
        return (_openBlock(), _createBlock(_component_ConnectProviderListItem, {
          onClick: ($event: any) => (_ctx.$emit('connect', p)),
          key: p.name,
          name: p.name,
          logo: p.logo,
          loading: false
        }, null, 8, ["onClick", "name", "logo"]))
      }), 128)),
      _hoisted_2,
      (_ctx.providers.length > 3)
        ? (_openBlock(), _createBlock(_component_ConnectProviderListItem, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.providersCollapsed = !_ctx.providersCollapsed)),
            name: _ctx.providersCollapsed ? 'Show fewer options' : 'Show more options'
          }, null, 8, ["name"]))
        : _createCommentVNode("", true)
    ])
  ]))
}